import React, { useEffect, useState } from 'react';
import { Grid, ListItemText, ListItem, Box, ToggleButton, ToggleButtonGroup  } from '@mui/material';
import ExpandMore from '@mui/icons-material/ExpandMore';
import ExpandLess from '@mui/icons-material/ExpandLess';
import { donorLinkFilters } from '../../../helpers/RescuesHelper';
import FilterComponent from './FilterComponent';

const FilterButton = ({ children, classes, ...rest }) => (
  <ToggleButton
    sx={{
      padding: '11px',
      height: '75px',
      minWidth: '50px',
      '&.Mui-selected': {
        backgroundColor: `primary.main`,
        color: '#fff',
        '&:hover': {
          backgroundColor: 'primary.main',
        },
      },
      '& .MuiGrid-container': {
        marginLeft: '4px',
        marginRight: '4px',
      },
    }}
    {...rest}
  >
    {children}
  </ToggleButton>
);

export const getDonorLinkLabel = selectedFilter => {
  if (!selectedFilter) {
    return 'Donor Link: all';
  }

  return `Donor Link: ${selectedFilter}`;
};

const DonorLinkSelectorFilter = ({ value, handleFilterChange }) => {
  const [isOpen, setIsOpen] = useState(false);
  const [selectedFilter, setSelectedFilter] = useState(value);
  const filters = [
    donorLinkFilters.dataReceived,
    donorLinkFilters.dataNotReceived,
    donorLinkFilters.donorLinkInactive,
    donorLinkFilters.donorLinkActive,
  ];

  useEffect(() => {
    handleFilterChange(selectedFilter);
  }, [selectedFilter]);

  return (
    <>
      <ListItem button onClick={() => setIsOpen(!isOpen)}>
        <ListItemText primary={getDonorLinkLabel(selectedFilter)} />
        {isOpen ? <ExpandMore /> : <ExpandLess />}
      </ListItem>
      <FilterComponent isOpen={isOpen}>
        <Box
          py={2}
          display="flex"
          justifyContent="center"
          alignItems="center"
          direction="row"
          flexGrow={1}
          flexBasis={0}
        >
          <ToggleButtonGroup
            size="medium"
            exclusive
            value={selectedFilter}
            onChange={(event, newValue) => setSelectedFilter(newValue)}
            aria-label="text alignment"
          >
            {filters.map((filter, index) => (
              <FilterButton key={index} value={filter}>
                <Grid container direction="column" justifyContent="center" alignItems="center">
                  <Grid>{filter}</Grid>
                </Grid>
              </FilterButton>
            ))}
          </ToggleButtonGroup>
        </Box>
      </FilterComponent>
    </>
  );
};

export default DonorLinkSelectorFilter;
